import { render, staticRenderFns } from "./_CoachesGroup.vue?vue&type=template&id=191ebea2"
import script from "./_CoachesGroup.vue?vue&type=script&lang=js"
export * from "./_CoachesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports